import { render, staticRenderFns } from "./KrefeldDocumentsPage.vue?vue&type=template&id=01484429&scoped=true&"
import script from "./KrefeldDocumentsPage.vue?vue&type=script&lang=js&"
export * from "./KrefeldDocumentsPage.vue?vue&type=script&lang=js&"
import style0 from "./KrefeldDocumentsPage.vue?vue&type=style&index=0&id=01484429&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01484429",
  null
  
)

export default component.exports